// ─────────────────────────────────────────────────────────────
// Firebase — Initialization (Modular SDK v10)
// Credentials read from .env — never hardcode here
// ─────────────────────────────────────────────────────────────
import { initializeApp, type FirebaseOptions } from 'firebase/app';
import { getAuth }                              from 'firebase/auth';
import { getDatabase }                          from 'firebase/database';
import { getStorage }                           from 'firebase/storage';

export const firebaseConfig: FirebaseOptions = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY    as string,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string,
  databaseURL:       import.meta.env.VITE_FIREBASE_DATABASE_URL as string,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID  as string,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID      as string,
};

const app = initializeApp(firebaseConfig);

export const auth    = getAuth(app);
export const db      = getDatabase(app);
export const storage = getStorage(app);
export default app;
